import type { CacheBusMessage, CacheEvent } from '../../types/main';

/**
 * Event when the bus receives a message
 */
export class BusMessageReceived implements CacheEvent {
  name = 'bus:message:received' as const;

  constructor(readonly message: CacheBusMessage) {}

  toJSON() {
    return {
      keys: this.message.keys,
      type: this.message.type,
    };
  }
}
